import { useEffect } from 'react'
import MailCalendarPage from '@os/calendar/web/CalendarPage'
import { useToastStore } from '../../stores/toastStore'

// Wraps the published @os/calendar workspace page with the OAuth-return
// toast effect (the package page can't be edited inside node_modules and
// doesn't expose its own toast hook). Sibling of MailDashboard.tsx's
// inline equivalent block — same shape, calendar-specific copy.
export default function CalendarWorkspacePage() {
  const showToast = useToastStore((s) => s.showToast)

  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    if (params.get('connected') === 'ok') {
      showToast({
        id: `calendar-connected-${Date.now()}`,
        type: 'message',
        title: 'Calendar account connected',
      })
      window.history.replaceState({}, '', window.location.pathname)
    }
    if (params.get('connected') === 'err') {
      const reason = params.get('reason') ?? 'unknown'
      showToast({
        id: `calendar-connect-err-${Date.now()}`,
        type: 'error',
        title: "Couldn't connect Google Calendar",
        body: `Reason: ${reason}. Try again or contact support.`,
      })
      window.history.replaceState({}, '', window.location.pathname)
    }
  }, [showToast])

  return <MailCalendarPage />
}
